import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yi-layout',
  template: require('./layout.component.html'),
  styles: [require('./layout.component.scss')]
})
export class LayoutComponent implements OnInit {

  isSmsInstall = false;

  constructor(private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    let inAppInstall = this.activatedRoute.snapshot.firstChild.data.inAppInstall;
    this.isSmsInstall = this.getProductIntent() === 'SMS' && inAppInstall;
  }

  private getProductIntent() {
    return this.activatedRoute.snapshot.queryParams['product'];
  }
}
